import React, { useEffect, useState } from "react";
import EmailIcon from "../../resources/landing-page/email.svg";
import PhoneIcon from "../../resources/landing-page/phone.svg";
import SnowScapeLogoWithWhiteText from "../../resources/logo/snowscape-logo-horizontal-with-white-text.svg";
import axiosContact from "../../services/axios/contact";
import SquareButton from "../../components/Buttons/SquareButton";
import BasicInput from "../../components/Inputs/BasicInput";
import BasicTextArea from "../../components/Inputs/BasicTextArea";
import SplitFormSmall from "../../components/SplitFormSmall";
import {
  phoneNumber,
  phoneNumberFormatted,
} from "../../pages/LandingPage/ContactUsPage";

const SuccessMessage = (
  <div className="flex flex-col flex-1 items-center justify-center">
    <div className="rounded-xl border-2 border-snow-green py-20 px-10 drop-shadow-xl">
      <div className="font-bold text-3xl text-center text-snow-green pb-6">
        Message Successfully Sent
      </div>
      <div className="font-bold text-xl text-center text-snow-green">
        We're excited to hear from you and will get back to you as quickly as
        possible!
      </div>
    </div>
  </div>
);
const ContactUsForm = () => {
  const [state, setState] = useState({
    email: "",
    name: "",
    message: "",
  });
  const [emailValid, setEmailValid] = useState(false);
  const [successfullySent, setSuccessfullySent] = useState(false);

  useEffect(() => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailValid(emailPattern.test(state.email));
  }, [state.email]);

  const handleSendMessage = async (e) => {
    e.preventDefault();

    const data = await axiosContact.sendContactUsEmail({
      type: "contact-us",
      ...state,
    });

    if (data.success) {
      setSuccessfullySent(true);
    }
  };

  const form = !successfullySent ? (
    <form className="flex flex-col">
      <BasicInput
        name="name"
        type="text"
        placeholder="John Doe"
        value={state.name}
        onChange={(value) => setState({ ...state, name: value })}
      />
      <BasicInput
        name="email"
        type="email"
        placeholder="your-email@gmail.com"
        value={state.email}
        onChange={(value) => setState({ ...state, email: value })}
      />
      <BasicTextArea
        name="message"
        placeholder="Type your message here..."
        value={state.message}
        onChange={(value) => setState({ ...state, message: value })}
        rows={5}
      />
      <SquareButton
        label="Send Message"
        color="blue-gradient"
        onClick={handleSendMessage}
        className="max-w-none"
        disabled={!state.email || !state.name || !state.message || !emailValid}
      />
    </form>
  ) : (
    SuccessMessage
  );

  return (
    <SplitFormSmall
      leftContent={
        <>
          <div className="text-snow-white text-2xl font-bold text-left pr-4">
            Have questions? Ask us here!
          </div>
          <div className="mt-10">
            <img
              alt="snowscape-logo"
              className="w-44"
              src={SnowScapeLogoWithWhiteText}
            />
            <div className="mt-4">
              <div className="flex items-center gap-4">
                <img src={EmailIcon} alt="email-icon" className="w-6 h-6" />
                <a
                  className="text-snow-white"
                  href="mailto:info@mysnowscape.com"
                >
                  info@mysnowscape.com
                </a>
              </div>
              <div className="flex items-center gap-4 mt-4">
                <img src={PhoneIcon} alt="phone-icon" className="w-6 h-6" />
                <a className="text-snow-white" href={`tel:${phoneNumber}`}>
                  {phoneNumberFormatted}
                </a>
              </div>
            </div>
          </div>
        </>
      }
    >
      {form}
    </SplitFormSmall>
  );
};

export default ContactUsForm;
export { SuccessMessage };
